<ng-template #save>
  <div style="align-self: end;">
    <app-save-button [disabled]="!this.form.touched"
    (clickEvent)="saveForm()"></app-save-button>
  </div>
</ng-template>

<div class="flex gap-3 w-full pt-2" style="justify-content: space-between;">

  <!-- Collection Category -->
  @if (settings?.key === OrganizationSettingTypeEnum.COLLECTION_CATEGORY) {
    <div class="flex flex-column gap-3">
      @if ((form.controls?.['categories'] || []); as fgArray) {
        <div class="flex gap-1 align-items-center">
          <div class="textSubheader">{{ 'organization-settings.collectionCategory.label' | translate }}</div>
          <app-button icon="pi-plus" severity="success" [rounded]="true" [text]="true"
          (clickEvent)="addFormRow(fgArray, createCollectionCategoryForm)"></app-button>
        </div>
        <div class="grid-4col_auto input-grid-gaps align-items-center">
          @for (fg of fgArray.controls || []; track fg; let index = $index) {
            <app-text-input [form]="$any(fg)" id="name"
            label="organization-settings.collectionCategory.fields.name"></app-text-input>
            <app-select-input
              [form]="$any(fg)"
              id="threshold"
              label="organization-settings.collectionCategory.fields.threshold"
              [staticOptions]="donorCategoryThresholdOptions"
              valueKey="id">
              <ng-template #item let-data>
                {{ ('donor.regularities.' + (data?.id ?? data)) | translate }}
              </ng-template>
              <ng-template #selectedItem let-data>
                {{ ('donor.regularities.' + (data?.id ?? data)) | translate }}
              </ng-template>
            </app-select-input>
            <app-text-input [form]="$any(fg)" id="priority"
            label="organization-settings.collectionCategory.fields.priority"></app-text-input>
            <app-delete-button [hideLabel]="true" [rounded]="true" [text]="true"
            (clickEvent)="removeFormRow(fgArray, index)"></app-delete-button>
          }
        </div>
      }
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /Collection Category -->

  <!-- HealthCare and social services settings-->
  @if (settings?.key === OrganizationSettingTypeEnum.HEALTHCARE_SOCIAL_SETTINGS) {
    <div class="flex flex-column gap-3"></div>
  }
  <!-- /HealthCare and social services settings-->

  <!-- Donation Forms -->
  <ng-template #defaultDonationForm>
    @if (store.isIntegrationActive$.donationForm | async) {
      <app-select-input
        id="defaultDonationForm"
        [form]="form"
        [staticOptions]="store.donationForms$ | async"
        valueKey="id"
        labelKey="name"
        label="organization-settings.donationForm.default"
        [showClear]="true"
        [autoDisplayFirst]="false"
        class="mt-1">
      </app-select-input>
    } @else {
      {{ 'organization-settings.donationForm.requiredForDefaultForm' | translate }}
    }
  </ng-template>

  @if (settings?.key === OrganizationSettingTypeEnum.DONATION_FORM) {
    <div class="flex gap-3 w-full  pt-2">
      <div class="flex flex-column gap-3">
        @if ((form.controls?.['forms'] || []); as fgArray) {
          <div class="flex gap-1 align-items-center">
            <div class="textSubheader">{{ 'organization-settings.donationForm.label' | translate }}</div>
            <app-button icon="pi-plus" [rounded]="true" [text]="true"
            (clickEvent)="addFormRow(fgArray, createDonationFormForm)"></app-button>
          </div>
          <div class="grid-3col_auto input-grid-gaps align-items-center">
            <div></div>
            <div class="flex gap-1 align-items-end"
              [pTooltip]="'organization-settings.donationForm.isDonationHint' | translate"
              tooltipPosition="top">
              <span>{{ 'organization-settings.donationForm.fields.isDonation' | translate }}</span>
              <i class="pi pi-question-circle" style="font-size: 1rem;"></i>
            </div>
            <div></div>
            @for (fg of fgArray.controls || []; track fg; let index = $index) {
              <app-text-input [form]="$any(fg)" id="name"
              label="organization-settings.donationForm.fields.name"></app-text-input>
              <app-check-input [form]="$any(fg)" id="isDonation" [showLabel]="false"></app-check-input>
              <app-delete-button [hideLabel]="true" [rounded]="true" [text]="true"
              (clickEvent)="removeFormRow(fgArray, index)"></app-delete-button>
            }
          </div>
        }
        <ng-container [ngTemplateOutlet]="save"></ng-container>
      </div>
      @if ($any(this.form.value).forms?.length) {
        <div class="pt-2">
          <app-select-input
            id="defaultGatewayForm"
            [form]="form"
            [staticOptions]="$any(this.form.value).forms"
            valueKey="id"
            labelKey="name"
            label="organization-settings.donationForm.defaultGatewayForm"
            [showClear]="true"
            [autoDisplayFirst]="false">
          </app-select-input>
        </div>
      }
    </div>
  }
  <!-- /Donation Forms  -->

  <!-- Darujme -->
  @if (settings?.key === OrganizationSettingTypeEnum.DARUJME) {
    <div class="flex gap-3">
      <div class="flex flex-column gap-3" style="width: 20rem;">
        <app-number-input [form]="form" id="organizationId" class="mt-1"
        label="organization-settings.darujme.fields.organizationId"></app-number-input>
        <app-text-input [form]="form" id="apiId"
        label="organization-settings.darujme.fields.apiId"></app-text-input>
        <app-password-input [form]="form" id="apiSecret"
        label="organization-settings.darujme.fields.apiSecret"></app-password-input>
        <app-text-input [form]="form" id="fallbackCollectionId"
        label="organization-settings.darujme.fields.fallbackCollectionId"></app-text-input>
        <ng-container [ngTemplateOutlet]="save"></ng-container>
      </div>
      <div class="flex flex-column gap-3">
        <ng-container [ngTemplateOutlet]="defaultDonationForm"></ng-container>
      </div>
    </div>
  }
  <!-- /Darujme -->

  @if (settings?.key === OrganizationSettingTypeEnum.WEB_GATEWAY) {
    <app-organization-settings-web-gateway
      class="w-full"
      [settings]="webGatewaySettings"
      (save)="saveForm($event)"
    ></app-organization-settings-web-gateway>
  }

  <!-- Sporitelna -->
  @if (settings?.key === OrganizationSettingTypeEnum.SPORITELNA) {
    <div class="flex flex-column gap-3">
      <div class="flex gap-3">
        <div class="flex flex-column gap-3" style="width: 20rem;">
          @if (store.data.banks$ | async; as banks;) {
            <div
              class="textSubheader">{{ 'organization-settings.sporitelna.bankAccountsMapping' | translate }}
            </div>
            @if (banks.length) {
              <ng-container class="overflow-auto" style="max-height: 25rem;">
                @for (bank of banks; track bank) {
                  <app-sporitelna-bank-account [account]="bank"></app-sporitelna-bank-account>
                  <app-text-input [form]="form.controls['bankMapping']"
                    [id]="bank.identification.iban"
                  label="organization-settings.sporitelna.fields.collectionId"></app-text-input>
                  <p-divider></p-divider>
                }
              </ng-container>
            }
            @if (!banks.length) {
              @for (bank of (form.value['bankMapping'] || {}) | keyvalue; track bank) {
                <app-text-input
                  [form]="form.controls['bankMapping']"
                  [id]="$any(bank.key)"
                [label]="$any(bank.key)"></app-text-input>
              }
            }
          }
          <app-text-input [form]="form" id="fallbackCollectionId"
          label="organization-settings.sporitelna.fields.fallbackCollectionId"></app-text-input>
        </div>
        <div class="flex flex-column gap-3">
          <div class="textSubheader">{{ 'organization-settings.sporitelna.defaults' | translate }}
          </div>
          <ng-container [ngTemplateOutlet]="defaultDonationForm"></ng-container>
          @if (store.integrationData$.donationForm | async;) {
            <app-select-input
              id="defaultDonationFormForCashTransfer"
              [form]="form"
              [staticOptions]="store.donationForms$ | async"
              valueKey="id"
              labelKey="name"
              label="organization-settings.sporitelna.defaultDonationFormForCashTransfer"
              [showClear]="true"
              [autoDisplayFirst]="false">
            </app-select-input>
          }
          @if ((form.controls?.['accountToForm'] || []); as fgArray) {
            <div class="flex gap-1 align-items-center">
              <div
                class="textSubheader">{{ 'organization-settings.sporitelna.bankAccountForceForm' | translate }}
              </div>
              <i class="pi pi-question-circle" style="font-size: 1rem;"
                [pTooltip]="'organization-settings.sporitelna.bankAccountToIban' | translate"
              tooltipPosition="top"></i>
              <app-button icon="pi-plus" [rounded]="true" [text]="true"
              (clickEvent)="addFormRow(fgArray, createSporitelnaAccountToFormForm)"></app-button>
            </div>
            <div class="grid-3col_auto input-grid-gaps align-items-center overflow-auto pt-2"
              style="max-height: 25rem;">
              @for (fg of fgArray.controls || []; track fg; let index = $index) {
                <app-text-input
                  [form]="$any(fg)"
                  id="iban"
                  [valueTransform]="tryConvertCzechAccountToIban"
                  label="organization-settings.sporitelna.bankAccount">
                </app-text-input>
                <app-select-input
                  id="donationForm"
                  [form]="$any(fg)"
                  [staticOptions]="store.donationForms$ | async"
                  valueKey="id"
                  labelKey="name"
                  label="organization-settings.sporitelna.donationForm"
                  [autoDisplayFirst]="true">
                </app-select-input>
                <app-delete-button [hideLabel]="true" [rounded]="true" [text]="true"
                (clickEvent)="removeFormRow(fgArray, index)"></app-delete-button>
              }
            </div>
          }
        </div>
        <div>
          <a [href]="redirectUrl"
          class="p-button p-button-success">{{ 'organization-settings.sporitelna.login' | translate }}</a>
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /Sporitelna -->

  <!-- Raiffeisen -->
  @if (settings?.key === OrganizationSettingTypeEnum.RAIFFEISEN) {
    <div class="flex flex-column gap-3 overflow-visible">
      <div class="flex gap-3">
        <div class="flex flex-column gap-3" style="width: 20rem;">
          @if ((settingsData['accounts'] || {}); as accounts;) {
            <div
              class="textSubheader">{{ 'organization-settings.raiffeisen.bankAccountsMapping' | translate }}
            </div>
            @if (accounts.length) {
              <ng-container class="overflow-auto" style="max-height: 25rem;">
                @for (account of accounts; track account) {
                  <div class="flex flex-column">
                    <div>{{ account.name }}</div>
                    <div class="text-500">{{ account.iban }}</div>
                  </div>
                  <app-text-input [form]="form.controls['bankMapping']"
                    [id]="account.iban"
                  label="organization-settings.raiffeisen.fields.collectionId"></app-text-input>
                  <p-divider></p-divider>
                }
              </ng-container>
            }
            @if (!accounts.length) {
              @for (bank of (form.value['bankMapping'] || {}) | keyvalue; track bank) {
                <app-text-input
                  [form]="form.controls['bankMapping']"
                  [id]="$any(bank.key)"
                [label]="$any(bank.key)"></app-text-input>
              }
            }
          }
          <app-text-input [form]="form" id="fallbackCollectionId"
          label="organization-settings.sporitelna.fields.fallbackCollectionId"></app-text-input>
        </div>
        <div class="flex flex-column gap-3 overflow-visible">
          <div class="textSubheader">{{ 'organization-settings.raiffeisen.defaults' | translate }}</div>
          <ng-container [ngTemplateOutlet]="defaultDonationForm"></ng-container>
          @if ((form.controls?.['accountToForm'] || []); as fgArray) {
            <div class="flex gap-1 align-items-center">
              <div
                class="textSubheader">{{ 'organization-settings.raiffeisen.bankAccountForceForm' | translate }}
              </div>
              <i class="pi pi-question-circle" style="font-size: 1rem;"
                [pTooltip]="'organization-settings.raiffeisen.bankAccountToIban' | translate"
              tooltipPosition="top"></i>
              <app-button icon="pi-plus" [rounded]="true" [text]="true"
              (clickEvent)="addFormRow(fgArray, createRaiffeisenAccountToFormForm)"></app-button>
            </div>
            <div class="grid-3col_auto input-grid-gaps align-items-center pt-2"
              style="max-height: 25rem;">
              @for (fg of fgArray.controls || []; track fg; let index = $index) {
                <app-text-input [form]="$any(fg)" id="iban"
                  [valueTransform]="tryConvertCzechAccountToIban"
                label="organization-settings.raiffeisen.bankAccount"></app-text-input>
                <app-select-input
                  id="donationForm"
                  [form]="$any(fg)"
                  [staticOptions]="store.donationForms$ | async"
                  valueKey="id"
                  labelKey="name"
                  label="organization-settings.raiffeisen.donationForm"
                  [autoDisplayFirst]="true">
                </app-select-input>
                <app-delete-button [hideLabel]="true" [rounded]="true" [text]="true"
                (clickEvent)="removeFormRow(fgArray, index)"></app-delete-button>
              }
              <p-datePicker
                [(ngModel)]="date"
                dateFormat="dd.mm.yy"
                [iconDisplay]="'input'"
                [showIcon]="true"
                />
              <app-button label="Sync" (clickEvent)="syncRaiff()"></app-button>
            </div>
          }
        </div>
        <div class="flex flex-column gap-3">
          <div class="flex gap-2 align-items-center">
            <div>{{ 'organization-settings.raiffeisen.fields.certificate' | translate }}</div>
            <p-fileupload
              #upload
              class="button-over-preview upload_position"
              mode="basic"
              name="cert[]"
              [auto]="true"
              [customUpload]="true"
              [fileLimit]="1"
              chooseIcon="pi pi-upload"
              (uploadHandler)="onCertUpload($event)"
            ></p-fileupload>
            @if (this.form.value['certFilepath']?.length) {
              <app-check-or-cross
              [value]="true"></app-check-or-cross>
            }
          </div>
          <app-text-input [form]="form" id="clientId"
          label="organization-settings.raiffeisen.fields.clientId"></app-text-input>
          <app-password-input [form]="form" id="certPassword"
          label="organization-settings.raiffeisen.fields.certificatePassword"></app-password-input>
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /Raiffeisen -->

  <!-- Password reset -->
  @if (settings?.key === OrganizationSettingTypeEnum.PASSWORD_RESET) {
    <div class="flex flex-column gap-3">
      <app-number-input
        [form]="form"
        id="expireInMonths"
        label="organization-settings.passwordReset.fields.expireInMonths"
        [min]="1"
        [max]="99"
        class="mt-1"
      ></app-number-input>
      <app-check-input [form]="form" id="applyTo2Fa"
        label="organization-settings.passwordReset.fields.applyTo2Fa"
      ></app-check-input>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /Password reset -->

  <!-- Trash settings -->
  @if (settings?.key === OrganizationSettingTypeEnum.TRASH_SETTINGS) {
    <app-organization-trash-settings
      [settings]="settings!"
    ></app-organization-trash-settings>
  }
  <!-- /Trash settings -->

  <!-- System settings -->
  @if (settings?.key === OrganizationSettingTypeEnum.SYSTEM_SETTINGS) {
    <div class="flex flex-column gap-3">
      <app-switch-input [form]="form" id="topbarVideocall"
      label="organization-settings.systemSettings.fields.topbarVideocall"></app-switch-input>
      <app-switch-input [form]="form" id="topbarFullscreen"
      label="organization-settings.systemSettings.fields.topbarFullscreen"></app-switch-input>
      <app-switch-input [form]="form" id="topbarSearch"
      label="organization-settings.systemSettings.fields.topbarSearch"></app-switch-input>
      <app-switch-input [form]="form" id="topbarHelp"
      label="organization-settings.systemSettings.fields.topbarHelp"></app-switch-input>
      <app-switch-input [form]="form" id="topbarUserEmail"
      label="organization-settings.systemSettings.fields.topbarUserEmail"></app-switch-input>
      <app-switch-input [form]="form" id="topbarUserOffice"
      label="organization-settings.systemSettings.fields.topbarUserOffice"></app-switch-input>
      <app-switch-input [form]="form" id="topbarUserReports"
      label="organization-settings.systemSettings.fields.topbarUserReports"></app-switch-input>
      <app-switch-input [form]="form" id="topbarUserReadMessages"
      label="organization-settings.systemSettings.fields.topbarUserReadMessages"></app-switch-input>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /System settings -->

  <!-- Emailing settings -->
  @if (settings?.key === OrganizationSettingTypeEnum.EMAILING_SETTINGS) {
    <div class="flex flex-column gap-3">
      <app-text-input [form]="form" id="emailAddress"
      label="organization-settings.emailingSettings.fields.emailAddress"></app-text-input>
      <app-text-input [form]="form" id="replyToAddress"
      label="organization-settings.emailingSettings.fields.replyToAddress"></app-text-input>
      <app-text-input [form]="form" id="postmarkToken"
      label="organization-settings.emailingSettings.fields.serverToken"></app-text-input>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /Emailing settings -->

    <!-- Email client settings -->
    @if (settings?.key === OrganizationSettingTypeEnum.EMAIL_CLIENT_SETTINGS) {
        <div class="width-stretch">
            <app-microsoft-graph-keys-setting></app-microsoft-graph-keys-setting>
        </div>
    }
    <!-- /Email client settings -->

  <!-- Software602 signing settings -->
  @if (settings?.key === OrganizationSettingTypeEnum.SOFTWARE602_SIGNING) {
    <div class="flex flex-column gap-3 pt-2">
      <app-text-input [form]="form" id="baseUrl"
      label="organization-settings.software602Signing.fields.baseUrl"></app-text-input>
      <app-text-input [form]="form" id="agendaIdent"
      label="organization-settings.software602Signing.fields.agendaIdent"></app-text-input>
      <app-text-input [form]="form" id="messageIdent"
      label="organization-settings.software602Signing.fields.messageIdent"></app-text-input>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /Software602 signing settings -->

  <!-- Mado settings -->
  @if (settings?.key === OrganizationSettingTypeEnum.MADO) {
    <div class="flex flex-column">
      <app-organization-settings-mado [form]="form"></app-organization-settings-mado>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
      <p-divider class="mb-3"></p-divider>
      <app-organization-settings-fiscal-year></app-organization-settings-fiscal-year>
      <app-organization-settings-department></app-organization-settings-department>
      <app-organization-settings-project></app-organization-settings-project>
      <app-organization-settings-budget-chapter></app-organization-settings-budget-chapter>
      <app-organization-settings-currency></app-organization-settings-currency>
      <app-organization-settings-journal></app-organization-settings-journal>
      <app-organization-settings-vat-code></app-organization-settings-vat-code>
    </div>
  }

  @if (settings?.key === OrganizationSettingTypeEnum.MADO_SETTINGS) {
    <div class="flex flex-column">
      <app-organization-settings-mado-transactions [form]="form"></app-organization-settings-mado-transactions>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }

  @if (settings?.key === OrganizationSettingTypeEnum.MADO_CREDIT_AGREEMENTS) {
    <div class="flex flex-column">
      <app-organization-settings-mado-credit-agreements [form]="form"></app-organization-settings-mado-credit-agreements>
      <ng-container [ngTemplateOutlet]="save"></ng-container>
    </div>
  }
  <!-- /Mado settings -->

  <div class="flex flex-column gap-2" style="align-items: end;">
    <app-switch-input [form]="commonForm" id="active" style="justify-self: start;"
    label="organization-settings.active"></app-switch-input>
    <app-delete-button [hideLabel]="true" styleClass="flex-1" [rounded]="true"
      [pTooltip]="'organization-settings.delete.title' | translate"
    (clickEvent)="delete()"></app-delete-button>
    <div style="height: 5rem;"></div>
    <div>{{ 'common.createdAt' | translate }}: {{ settings?.createdAt | localDate }}</div>
    <div>{{ 'common.updatedAt' | translate }}: {{ settings?.updatedAt | localDate }}</div>
  </div>
</div>
